import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostManualLabel = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.shippingCostManual.label;

export const label = setCalculationModeShippingCostManualLabel(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_SHIPPING_COST_MANUAL_LABEL',
  ''
);
